/* index.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./index.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { forwardRef } from 'react';
var baseStyles = null;
var justifyStartStyles = null;
var justifyEndStyles = null;

/**
 * __Tag group__
 *
 * A tag group controls the layout and alignment for a collection of tags.
 *
 * - [Examples](https://atlassian.design/components/tag-group/examples)
 * - [Code](https://atlassian.design/components/tag-group/code)
 * - [Usage](https://atlassian.design/components/tag-group/usage)
 */
var TagGroup = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$alignment = _ref.alignment,
    alignment = _ref$alignment === void 0 ? 'start' : _ref$alignment,
    titleId = _ref.titleId,
    label = _ref.label,
    children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    role: "group",
    ref: ref,
    "aria-label": label,
    "aria-labelledby": titleId,
    className: ax(["_1e0c1txw _1bsb1osq _1n261g80", alignment === 'start' && "_1bah1y6m", alignment === 'end' && "_1bahesu3"])
  }, children);
});
export default TagGroup;